import { render, staticRenderFns } from "./ModalCardDelete.vue?vue&type=template&id=116ed6a6&"
import script from "./ModalCardDelete.vue?vue&type=script&lang=js&"
export * from "./ModalCardDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports